import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import PlatformTable from "../../../modules/PC/pagination";
import BodyLoading from "../../../modules/Loading/BodyLoading";
import parse from "html-react-parser";
import PopUpModal from "../../../modules/Modal/PopUpModal";

export default function ManageUsers() {
  const navigator = useNavigate();
  const [show, setShow] = useState(false);

  // query params
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(0);

  // pagination params
  const [totalRows, setTotalRows] = useState(0);
  const [totalPage, setTotalPage] = useState(0);

  //data
  const [userList, setUserlist] = useState([]);
  const [userTemplate, setUserTemplate] = useState("");
  //loading
  const [loading, setLoading] = useState(true);

  const fetchUser = async () => {
    setLoading(true);

    try {
      const queryParams = { limit: pageSize, offset: pageSize * page };
      const res = await axios.post("/users", queryParams);
      if (res) {
        setUserlist(res.data.users);
        setTotalRows(res.data.totalCount);
        setTotalPage(Math.ceil(res.data.totalCount / pageSize));
      }
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  const next = () => {
    if (totalPage > page + 1) {
      let currentPage = page;
      currentPage++;
      setPage(currentPage);
    }
  };

  const previous = () => {
    if (page > 0) {
      let currentPage = page;
      currentPage--;
      setPage(currentPage);
    }
  };

  // const openContactUsInformation = (contactUs) => {
  //   setShowContactUsViewModal(true);
  //   setSelectedForView(contactUs);
  // };

  const deleteUser = async (user) => {
    try {
      if (user && user.id) {
        setLoading(true);

        const response = await axios.delete("/user/" + user.id);
        if (response.data.status === 200) {
          fetchUser();
          setLoading(false);

          toast.success(response.data.message, {
            closeOnClick: true,
            theme: "colored",
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const viewUser = async (user) => {
    try {
      setLoading(true);
      const response = await axios.get(`/user/view/${user.id}`);
      const res = await response.data;
      setLoading(false);
      if (res.status === 200) {
        if (res.user.my_signature !== null) {
          setUserTemplate(res.user);
          setShow(true);
        } else {
          alert("User Siganture is not available");
        }
      } else {
        console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const tableColumnMappings = [
    {
      column: "#",
      isIndex: true,
      classes: "text-platform-gray-dark font-size-20",
    },
    { column: "name", dataColumn: "name", classes: "font-size-18" },
    { column: "email", dataColumn: "email", classes: "font-size-18" },
    {
      column: "created_at",
      dataColumn: "created_at",
      classes: "font-size-18",
      isDateTime: true,
    },
    {
      column: "",
      isAction: true,

      actions: [
        {
          actionType: "function",
          functionRef: viewUser,
          text: "View User Signature",
          confirmAction: false,
        },
        // { actionType: "url", url: "/admin/user/view", text: "View" },
        { actionType: "url", url: "/admin/user/edit", text: "edit" },
        {
          actionType: "function",
          functionRef: deleteUser,
          text: "delete",
          confirmAction: true,
          confirmActionText: "Are you sure want to delete User(s)?",
          confirmButtonText: "delete",
        },
      ],
    },
  ];

  useEffect(() => {
    fetchUser();
  }, [pageSize, page]);

  return (
    <div className="container-fluid">
      {loading ? <BodyLoading /> : null}
      <div className="card text-start my-4 border-0 shadow">
        <div className="card-header border-bottom-0 admin-bg-primary text-white ">
          <h4>
            Manage Users
            <button
              onClick={() => {
                navigator("/admin/user/add");
              }}
              className="btn btn-secondary btn-sm float-end"
            >
              <FontAwesomeIcon icon={faPlus} /> Add User
            </button>
          </h4>
        </div>
        <div className="card-body">
          <PlatformTable
            tableColumnMappings={tableColumnMappings}
            dataSource={userList}
            pageSize={pageSize}
            setPageSize={setPageSize}
            totalPage={totalPage}
            totalRows={totalRows}
            page={page}
            next={next}
            previous={previous}
            isAllowMultiSelect={true}
          />
        </div>
        {show ? (
          <PopUpModal
            centered="true"
            title={`${userTemplate.name}'s Template`}
            size="lg"
            setmodalstate={setShow}
            backdrop="false"
          >
            <div className="container d-flex align-items-center justify-content-center  p-4">
              {parse(userTemplate.my_signature.html)}
            </div>
          </PopUpModal>
        ) : null}
      </div>
    </div>
  );
}
